/**
 * Descrição de vencimento para exibição de um plano na listagem.
 *
 * O backend guarda um `dueDay` mesmo quando o tipo de vencimento é
 * "no dia da contratação" (immediate_charge) — nesse caso o número é apenas
 * o dia em que a configuração foi salva e NÃO representa um dia de vencimento.
 * Por isso a exibição precisa ser dirigida pelo `dueType`, não pelo `dueDay`.
 */
export type DueDisplay = {
  label: string
  value: string
}

const daysSuffix = (dueDay: number) =>
  `${dueDay} ${dueDay > 1 ? 'dias' : 'dia'} após a contratação`

export const getPlanDueDisplay = (
  dueType?: string,
  // `due_day` chega como number (model Products) ou string (autocomplete da API)
  rawDueDay?: number | string | null
): DueDisplay | null => {
  const dueDay =
    rawDueDay !== undefined && rawDueDay !== null && rawDueDay !== ''
      ? Number(rawDueDay)
      : undefined

  switch (dueType) {
    case 'immediate_charge':
      return { label: 'Vencimento', value: 'No dia da contratação' }
    case 'immediate_charge_and_specified_charge':
      return {
        label: 'Vencimento',
        value: dueDay
          ? `No dia da contratação (demais no dia ${dueDay}, a partir do próximo mês)`
          : 'No dia da contratação'
      }
    case 'immediate_charge_and_same_month_specified_charge':
      return {
        label: 'Vencimento',
        value: dueDay
          ? `No dia da contratação (demais no dia ${dueDay}, já neste mês)`
          : 'No dia da contratação'
      }
    case 'delay_charge':
      return dueDay ? { label: 'Vencimento', value: daysSuffix(dueDay) } : null
    case 'delay_charge_and_specified_charge':
      return dueDay
        ? {
            label: 'Vencimento',
            value: `${daysSuffix(dueDay)} (demais no dia ${dueDay})`
          }
        : null
    case 'specified_charge':
      return dueDay
        ? { label: 'Dia do vencimento', value: String(dueDay) }
        : null
    default:
      // fixed_date / legado / desconhecido: mantém comportamento antigo
      return dueDay
        ? { label: 'Dia do vencimento', value: String(dueDay) }
        : null
  }
}
